module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_okunai_studio_plus_house-2e7c1e34764592888e67fd17d14af2da.jpg";